import useTestId from '@ori/testid-generator';
import type { PropsWithChildren, FC } from 'react';

import { CONTENT_TEXT } from './constants';
import { Root } from './styles';

export const ContentText: FC<PropsWithChildren> = ({ children }) => {
  const { getTestId } = useTestId();

  return <Root data-testid={getTestId(CONTENT_TEXT)}>{children}</Root>;
};
